export const CURRENT_JOB_ISSUES_FIELD_OTHER_TEXTFIELD_TRANSITIONS_PROPS = {
    initial: {
        opacity: 0,
        x: '-20px',
        transitionDuration: '0.3s'
    },
    enter: {
        opacity: 1,
        x: 0
    },
    exit: {
        opacity: 0,
        x: '-20px'
    }
};
